import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { productosPath, key_user_info } from '../helpers/constants';
import { getLocalStorage } from '../helpers/helper';

@Injectable({
  providedIn: 'root',
})
export class PolizaGuard implements CanActivate {
  constructor(public auth: AuthService, public router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const data = getLocalStorage(key_user_info);
    const poliza = data.polizas.find(p => p === route.params.id);
    if (!poliza) {
      this.router.navigate([productosPath.path]);
      return false;
    }
    return true;
  }
}
